const { trackMetric } = require('../collector');
const {
  APP_NAME,
  SCOPE_NAME,
  DEVICE,
  PLATFORM_ID,
  SITE_ID,
  WEBVIEW,
  REQUEST_ID,
  VIEW_NAME,
  USER_ID,
} = require('../../constants/metrics');
const pick = require('../utils/pick');
const { getUserId, getPath } = require('../utils/user-id');

const monitor = (settings) => {
  const data = pick(settings, [
    APP_NAME,
    SCOPE_NAME,
    DEVICE,
    PLATFORM_ID,
    SITE_ID,
    WEBVIEW,
    REQUEST_ID,
  ]);

  const viewName = getPath();
  if (viewName) {
    trackMetric(VIEW_NAME, viewName);
  }

  const userId = getUserId();
  if (userId) {
    trackMetric(USER_ID, parseInt(userId, 10));
  }

  Object.keys(data).forEach((key) => {
    // eslint-disable-next-line security/detect-object-injection
    if (data[key]) {
      // eslint-disable-next-line security/detect-object-injection
      trackMetric(key, data[key]);
    }
  });
};

module.exports = monitor;
